import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerEmailAddressUsernameRequest extends BaseUpdateRequest {
    emailAddress: string;     
}